import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { countryData } from "../Data";
import BreadCrumb from "../Components/BreadCrumb";
import NotFound from "./NotFound";
import MineralIntro from "../Components/MineralIntro";
import CountryCta from "../Components/CountryCta";
import CountryProductGrid from "../Components/CountryProductGrid";
import CountryInfo from "../Components/CountryInfo";
import MineralCta from "../Components/MineralCta";
import CountryStatCards from "../Components/CountryStatCards";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from "../Schema/BreadcrumbSchema";
import webPageSchema from "../Schema/WebPageSchema";
import collectionPageSchema from "../Schema/CollectionPageSchema";
import itemListSchema from "../Schema/ItemListSchema";

const CountryCommon=()=>{
        const { slug } = useParams();
      const Country = countryData.find(item => item.url === slug);
    
     useEffect(() => {
    if (!Country) return;
    document.title = Country.metaTitle;

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) metaDesc.setAttribute("content", Country.metaDescription);

      let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute(
    "href",
    `https://irisimpulse.com/${slug}`
  );

   const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
    Country.metaTitle
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
    Country.metaDescription
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content",  `https://irisimpulse.com/${slug}`);
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      (`https://irisimpulse.com${Country.bgImg}`)
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
    Country.metaTitle
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
    Country.metaDescription
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      (`https://irisimpulse.com${Country.bgImg}`)
    );
  }

}, [Country, slug]);

  if (!Country) return <NotFound />;

  const pageUrl = `https://irisimpulse.com/${slug}`;

const pageImage = Country.bgImg.startsWith("http")
  ? Country.bgImg
  : `https://irisimpulse.com/${Country.bgImg.replace(/^\/+/, "")}`;

const breadcrumbData = breadcrumbSchema({
  items: [
    {
      name: "Home",
      url: "https://irisimpulse.com/",
    },
    {
      name: Country.title,
    },
  ],
});

const webPageData = webPageSchema({
  url: pageUrl,
  title: Country.metaTitle,
  description: Country.metaDescription,
  image: pageImage,
});

const collectionData = collectionPageSchema({
  url: pageUrl,
  title: Country.metaTitle,
  description: Country.metaDescription,
  image: pageImage,
  itemListId: `${pageUrl}#itemlist`,
});

const itemListData = itemListSchema({
  url: pageUrl,
  name: `${Country.title} Products`,
  description: Country.metaDescription,
});

    return(
        <>
        <SchemaMarkup data={breadcrumbData} />
  <SchemaMarkup data={webPageData} />
  <SchemaMarkup data={collectionData} />
  <SchemaMarkup data={itemListData} />

         <React.Fragment key={slug}>

               <BreadCrumb
  title={Country.title}
  bgImage={Country.bgImg} 
/>
<div style={{marginTop:"80px"}}></div>

        {/**INTRODUCTION SECTION */}
         <MineralIntro
        subheading={Country.introSubHeading}
        heading={Country.introHeading}
        desc={Country.introPara}
        /*img={Country.introImg}*/
        videoUrl="https://www.youtube.com/embed/hdMu89Qd9H8?rel=0&modestbranding=1"
        showEnquireBtn={false}
        showContactBtn={false}
        />

        {/**ENQUIRE NOW SECTION */}
        <CountryCta
          heading={Country.ctaHeading}
          desc={Country.ctaDesc}
          country={Country}
        />

          {/**OTHER PRODUCTS SECTION */}
        <CountryProductGrid
          heading={Country.otherProductHeading}
          products={Country.products}
          countryUrl={Country.url}
        />

          {/**PACKING & STATS SECTION */}
    {Country.stats && Country.stats.length > 0 && (
  <CountryStatCards
    heading1={Country.packingHeading}
    para1={Country.packingDesc}
    heading2={Country.statsHeading}
    para2={Country.statsDesc}
    stats={Country.stats}
  />
)}


        {/**SLIDER SECTION */}
        <CountryInfo
          data={Country.sliderData}
          stats={Country.stats}
        />

        {/**CTA SECTION */}
         <MineralCta
        heading={Country.cta2Heading}
        desc={Country.cta2Desc}
        />

         {/**OTHER PRODUCTS SECTION */}
        <CountryProductGrid
          heading={Country.otherProductHeading2}
          products={Country.products2}
          countryUrl={Country.url}
        />

        <div style={{marginBottom:"80px"}}></div>

          </React.Fragment>
        </>
    )
}

export default CountryCommon; 